module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pdf-content-new"
  }, [(_vm.src) ? _c('div', {
    staticClass: "hasPdf"
  }, [(_vm.canReupload) ? _c('div', {
    staticClass: "btn-content"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload_btn",
    attrs: {
      "action": "/api/emer/plandoc/upload",
      "on-progress": _vm.onprogress,
      "headers": _vm.headers,
      "data": _vm.datalist,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "accept": ".xls,.xlsx,.doc,.docx,.txt,.pdf",
      "on-change": _vm.onChange,
      "beforeUpload": _vm.beforeUpload
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "只允许上传.xls,.xlsx,.doc,.docx,.txt,.pdf格式文件,若上传后显示异常，请转为pdf后再上传",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shangchuan"
  }, [_c('a', [_vm._v("重新上传")])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": '/static/pdf/web/viewer.html?file=' + encodeURIComponent(_vm.src),
      "width": "100%",
      "height": "100%"
    }
  })]) : _c('div', {
    staticClass: "noPdf"
  }, [(_vm.canReupload) ? _c('div', {
    staticClass: "btn-content"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload_btn",
    attrs: {
      "action": "/api/emer/plandoc/upload",
      "on-progress": _vm.onprogress,
      "headers": _vm.headers,
      "data": _vm.datalist,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "accept": ".xls,.xlsx,.doc,.docx,.txt,.pdf",
      "on-change": _vm.onChange,
      "beforeUpload": _vm.beforeUpload
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "只允许上传.xls,.xlsx,.doc,.docx,.txt,.pdf格式文件,若上传后显示异常，请转为pdf后再上传",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shangchuan"
  }, [_c('a', [_vm._v("上传")])])])], 1), _vm._v(" "), (_vm.datalist.type === 1 || _vm.datalist.type === 51) ? _c('div', {
    staticClass: "download-tips"
  }, [_c('div', {
    staticClass: "download-tips-content"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-warning is-big"
  }), _vm._v(" "), _c('p', {
    staticClass: "download-tips-infos"
  }, [_vm._v("请使用2020年最新的备案表，否则无法通过备案")]), _vm._v(" "), _c('em', {
    staticClass: "download-tips-button",
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载备案表模板")])])]) : _vm._e(), _vm._v(" "), (_vm.datalist.type === 1000) ? _c('div', {
    staticClass: "new-download-tips"
  }, [_c('div', {
    staticClass: "download-tips-content"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-warning is-big"
  }), _vm._v(" "), _c('em', {
    staticClass: "download-tips-button",
    on: {
      "click": _vm.downloadSimplifyTemplate
    }
  }, [_vm._v("下载简化备案表模板")])])]) : _vm._e(), _vm._v(" "), (_vm.datalist.type === 1001) ? _c('div', {
    staticClass: "new-download-tips"
  }, [_c('div', {
    staticClass: "download-tips-content"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-warning is-big"
  }), _vm._v(" "), _c('em', {
    staticClass: "download-tips-button",
    on: {
      "click": _vm.downloadPromiseCardTemplate
    }
  }, [_vm._v("下载环境安全责任承诺卡模板")])])]) : _vm._e(), _vm._v(" "), (_vm.datalist.type === 1002) ? _c('div', {
    staticClass: "new-download-tips"
  }, [_c('div', {
    staticClass: "download-tips-content"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-warning is-big"
  }), _vm._v(" "), _c('em', {
    staticClass: "download-tips-button",
    on: {
      "click": _vm.downloadRetrospectionTemplate
    }
  }, [_vm._v("下载回顾性评估表模板")])])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("只允许上传.xls,.xlsx,.doc,.docx,.txt,.pdf格式文件")]), _vm._v(" "), _c('p', [_vm._v("若上传后显示异常，请转为pdf后再上传")])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "文件上传中",
      "visible": _vm.uploadVisable,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadVisable = $event
      }
    }
  }, [_c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.percent
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.abort();
        _vm.uploadVisable = false
      }
    }
  }, [_vm._v("终止上传")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6453d915","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/pdfNew.vue
// module id = 1237
// module chunks = 2